export const publicHostname = "frontierstate.dev";
export const publicBaseUrl = `https://${publicHostname}`;

export const redirectToCanonicalHost = (request: Request): Response | undefined => {
  const url = new URL(request.url);
  if (url.hostname !== `www.${publicHostname}`) return undefined;
  url.hostname = publicHostname;
  return Response.redirect(url.toString(), 308);
};
